import { Component, OnInit, Input, Inject } from "@angular/core";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MedicalServiceService } from "../../../services/medical-service.service";
import { ClinicHistoryItem } from "../../../model/clinic-history-item";
import { MatTableDataSource, MatDialog } from "@angular/material";
// tslint:disable-next-line:max-line-length
import {
  StudyReportViewerDialogRequest,
  StudyReportViewerDialogComponent,
} from "../../dialogs/study-report-viewer/study-report-viewer-dialog.component";
import { PdfService } from "../../../services/pdf.service";
import { MedicalOrderScannViewComponent } from "../../dialogs/medical-order-scann-view/medical-order-scann-view-dialog.component";
import { DialogClinicalDataComponent } from "../../dialogs/dialog-clinical-data/dialog-clinical-data.component";
import { DialogCommentPreStudyReportComponent } from "../../dialogs/dialog-comment-pre-study-report/dialog-comment-pre-study-report.component";
import { StudyReportService } from "../../../services/study-report/study-report.service";
import {
  PacsService,
  pacsServiceFactory,
} from "src/app/services/pacs/pacs.service";
import { DataService } from "src/app/services/data.service";
import { AuthService } from "src/app/services/auth.service";
import { EnvironmentPresetService } from "src/app/services/environment-preset/environment-preset.service";

@Component({
  selector: "clinic-history-control-component",
  templateUrl: "./clinic-history-control.component.html",
  styleUrls: ["./clinic-history-control.component.css"],
})
export class ClinicHistoryControlComponent implements OnInit {
  dataSource = new MatTableDataSource([]);
  @Input() patientid: number;

  private pacsService: PacsService;

  loading: boolean;

  displayedColumns: string[] = [
    "DateTimeString",
    "PracticeRegionName",
    "Protocol",
    "Star",
  ];

  constructor(
    private notificationToastService: NotificationToastService,
    private dialog: MatDialog,
    private studyReportService: StudyReportService,
    private pdfService: PdfService,
    private medicalServiceService: MedicalServiceService,
    private dataService: DataService,
    private authService: AuthService,
    private environmentPresetService: EnvironmentPresetService,
    @Inject("BASE_URL") private baseUrl: string
  ) {

    this.pacsService = pacsServiceFactory(
      dataService,
      authService,
      environmentPresetService,
      baseUrl
    );
  }

  async studyReportView(clinicHistoryItem: ClinicHistoryItem) {
    try {
      if (clinicHistoryItem.StudyReportId) {
        const studyReportViewerDialogRequest =
          new StudyReportViewerDialogRequest();
        studyReportViewerDialogRequest.CanConfirm = false;
        const report = await this.studyReportService.getStudyReportPdf(
          clinicHistoryItem.StudyReportId
        );
        if (report && report.ReportBase64) {
          const pdfUrl = this.pdfService.base64ToPdfUrl(report.ReportBase64);
          studyReportViewerDialogRequest.SafeResourceUrl =
            this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
          this.dialog.open(StudyReportViewerDialogComponent, {
            width: "90%",
            height: "600px",
            data: studyReportViewerDialogRequest,
          });
        } else { 
          this.notificationToastService.error(
            "No existe informe confirmado para visualizar",
            "Historia clínica"
          );
        }
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Historia clínica"
      );
    } finally {
      this.loading = false;
    }
  }

  async viewPacs(clinicHistoryItem: ClinicHistoryItem) {
     try {
      const url = await this.pacsService.pacsViewerInfo(
        clinicHistoryItem.StudyReportId,
        ''
      );
      window.open(url, "_blank");
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err), "Informe");
    }
  }

  async clinicalDataView(clinicHistoryItem: ClinicHistoryItem) {
    const dialogRef = this.dialog.open(DialogClinicalDataComponent, {
      width: "50%",
      data: clinicHistoryItem.MedicalApponitmentId,
    });
  }

  async commentPreStudyReportView(clinicHistoryItem: ClinicHistoryItem) {
    const dialogRef = this.dialog.open(DialogCommentPreStudyReportComponent, {
      width: "50%",
      data: clinicHistoryItem.MedicalApponitmentId,
    });
  }

  medicalOrderScannView(clinicHistoryItem: ClinicHistoryItem): void {
    const dialogRef = this.dialog.open(MedicalOrderScannViewComponent, {
      width: "90%",
      height: "600px",
      data: { medicalorderId: clinicHistoryItem.MedicalOrderId },
    });
  }

  async ngOnInit() {
    try {
      this.loading = true;
      if (this.patientid > 0) {
        const clinicHistoryItems =
          await this.medicalServiceService.getClinicHistoryItems(
            this.patientid
          );
        this.dataSource = new MatTableDataSource(clinicHistoryItems);
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Historia clínica"
      );
    } finally {
      this.loading = false;
    }
  }
}
